module.exports = __webpack_public_path__ + "static/media/play-board-intro-2.c734a6b0.png";